<template>
  <footer id="footer" class="footer">
    <div class="section-container footer-top">
      <div class="footer-brand">
        <img
          src="@/assets/Abercode logo2.png"
          alt="Abercode"
          loading="lazy"
          decoding="async"
        />
        <p>
          Abercode Software Innovation membantu organisasi membangun sistem
          digital yang relevan, aman, dan berkelanjutan.
        </p>
        <div class="footer-social">
          <a href="https://www.abercode.com" target="_blank" rel="noreferrer" aria-label="Situs Web">
            <ion-icon name="globe-outline"></ion-icon>
          </a>
          <a
            href="https://www.linkedin.com/company/abercode-software-innovation/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <ion-icon name="logo-linkedin"></ion-icon>
          </a>
          <a
            href="https://www.instagram.com/abercode.software/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <ion-icon name="logo-instagram"></ion-icon>
          </a>
        </div>
      </div>

      <div class="footer-col">
        <h3>Kontak</h3>
        <a href="https://wa.me/6285162814545" target="_blank" rel="noreferrer">
          +62 851 6281 4545
        </a>
        <a href="mailto:abercode.software@gmail.com">abercode.software@gmail.com</a>
      </div>

      <div class="footer-col">
        <h3>Perusahaan</h3>
        <a href="#ourclient">Klien Kami</a>
        <a href="#services">Layanan</a>
        <a href="#howitworks">Cara Kerja</a>
        <a href="#portofolio">Portofolio</a>
        <a href="#aboutus">Tentang Kami</a>
      </div>

      <div class="footer-col">
        <h3>Sumber Daya</h3>
        <a href="#contactdetails">Konsultasi Proyek</a>
        <a href="#contactdetails">Pusat Bantuan</a>
        <a href="#footer">Privasi & Ketentuan</a>
      </div>
    </div>

    <div class="footer-bottom">
      <p>© PT Abercode Software Innovation {{ currentYear }}. Seluruh hak cipta dilindungi.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.footer {
  margin-top: 44px;
  color: #fff;
  background:
    radial-gradient(circle at 10% 10%, rgba(255, 255, 255, 0.1), transparent 35%),
    linear-gradient(145deg, #082a5d, #0e4ea7);
}

.footer-top {
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 24px;
  padding: 50px 20px 34px;
}

.footer-brand img {
  width: min(230px, 100%);
}

.footer-brand p {
  margin-top: 12px;
  max-width: 340px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.95rem;
}

.footer-social {
  margin-top: 16px;
  display: flex;
  gap: 8px;
}

.footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  transition: background 0.22s ease, transform 0.22s ease;
}

.footer-social a:hover {
  background: rgba(255, 255, 255, 0.22);
  transform: translateY(-2px);
}

.footer-social ion-icon {
  font-size: 1.14rem;
}

.footer-col {
  display: grid;
  gap: 8px;
  align-content: start;
}

.footer-col h3 {
  margin-bottom: 4px;
  font-size: 1rem;
  color: #fff;
}

.footer-col a {
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.92rem;
  line-height: 1.6;
  transition: color 0.2s ease;
}

.footer-col a:hover {
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 12px 20px;
  text-align: center;
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.86rem;
}

@media (max-width: 980px) {
  .footer-top {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 620px) {
  .footer-top {
    grid-template-columns: 1fr;
    padding-top: 38px;
  }
}
</style>
